/* istanbul ignore next */
let localStorageObj = {};

export default {
    getItem : function(key){
        if (window && window.localStorage) {
            return window.localStorage.getItem(key)
        } else {
            return localStorageObj[key];
        }
    },
    setItem : function(key, value) {
        if (window && window.localStorage) {
            return window.localStorage.setItem(key, value)
        } else {
            return localStorageObj[key] = value;
        }
    },
    removeItem : function(key){
        if (window && window.localStorage) {
            return window.localStorage.removeItem(key)
        } else {
            return delete localStorageObj[key];
        }
    }
};




// WEBPACK FOOTER //
// ./src/helpers/localStorage.js